<div class="navbar navbar-expand-md navbar-light shadow fixed-bottom d-block d-lg-none p-0">
	<div class="row no-gutters d-flex justify-content-between">
		<div class="col">
			<button
				mat-button
				class="no-hover w-100"
				matTooltip="{{ helpersService.instant('MENU.FTTH') }}"
				[disableRipple]="true"
			>
				<a class="nav-link" href="javascript:void(0);" routerLink="/home" routerLinkActive="active">
					<img
						src="{{ helpersService.pathImgsMarkers }}/noun_optical_fiber.svg"
						alt="'MENU.FTTH' | translate"
						class="icon-fiber"
					/>
				</a>
			</button>
		</div>

		<div class="col">
			<button
				mat-button
				matTooltip="{{ helpersService.instant('MENU.P2P') }}"
				class="no-hover w-100"
				[disableRipple]="true"
			>
				<a class="nav-link" href="javascript:void(0);" routerLink="/p2p" routerLinkActive="active">
					<img
						src="./assets/imgs/ico-servizi-disponibili.png?v={{ assets_version }}"
						srcset="./assets/imgs/ico-servizi-disponibili@2x.png 2x"
						alt="{{ 'MENU.P2P' | translate }}"
						class="icon-fiber"
					/>
				</a>
			</button>
		</div>

		<div class="col">
			<button
				mat-button
				matTooltip="{{ helpersService.instant('MENU.SERVICES') }}"
				class="no-hover w-100"
				[disableRipple]="true"
			>
				<a class="nav-link" href="javascript:void(0);" routerLink="/services-menu" routerLinkActive="active">
					<i class="fas fa-clipboard-list icon-fiber"></i>
				</a>
			</button>
		</div>

		<div *ngIf="helpersService.isAdmin" class="col">
			<button
				mat-button
				matTooltip="{{ helpersService.instant('MENU.MANAGEMENT') }}"
				class="no-hover w-100"
				[disableRipple]="true"
			>
				<a class="nav-link" href="javascript:void(0);" routerLink="/p2p_list" routerLinkActive="active">
					<i class="fas fa-sliders-h icon-fiber"></i>
				</a>
			</button>
		</div>

		<div class="col">
			<button
				mat-button
				matTooltip="{{ helpersService.instant('MENU.CONTACT') }}"
				class="no-hover w-100"
				[disableRipple]="true"
			>
				<a class="nav-link" href="javascript:void(0);" routerLink="/contact" routerLinkActive="active">
					<i class="far fa-comment-dots icon-fiber"></i>
				</a>
			</button>
		</div>

		<!-- <div *ngIf="helpersService.isAdmin" class="col">
            <button mat-button matTooltip="{{helpersService.instant('MENU.MANAGEMENT')}}" class="no-hover w-100"
                [disableRipple]="true">
                <a class="nav-link" href="javascript:void(0);" routerLink="/p2p_list" routerLinkActive="active">
                    <img src="{{helpersService.pathImgsMarkers}}/ico-login-registrazione.png" alt="'MENU.FTTH' | translate"
                        class="icon-fiber">
                </a>
            </button>
        </div> -->

		<div class="col">
			<button
				mat-button
				matTooltip="{{ helpersService.instant('LOGIN.LOGIN') }}"
				class="no-hover w-100"
				[disableRipple]="true"
				[class.d-none]="helpersService.isLogged"
				(click)="hideMap()"
			>
				<a *ngIf="!loading" href="javascript:void(0);" class="menulink nav-link" routerLink="/auth/login">
					<i class="fas fa-sign-in-alt"></i>
				</a>
				<mat-spinner *ngIf="loading"></mat-spinner>
			</button>
			<button
				mat-button
				matTooltip="{{ helpersService.instant('LOGIN.LOGOUT') }}"
				class="no-hover w-100"
				[disableRipple]="true"
				[class.d-none]="!helpersService.isLogged"
			>
				<a *ngIf="!loading" href="javascript:void(0);" class="menulink nav-link" (click)="logout()">
					<i class="fas fa-sign-out-alt"></i>
				</a>
				<mat-spinner *ngIf="loading"></mat-spinner>
			</button>
		</div>
	</div>
</div>
